/**
 * Image helper functions singleton
 */
class Images {
  constructor() {
  }

	/**
	 * Preload images. Takes an array of img sources and calls callback function after loading all
	 * @param {Array<string>} imageSources
	 * @param {function (Array<HTMLImageElement>)} done - callback function
	 */
  public preloadImages(imageSources: Array<string>, done: (loadedImages: Array<HTMLImageElement>) => void) {
    var images: Array<HTMLImageElement>,
      loadedImages: number,
      imageLoaded: () => void,
      i: number;


    images = [];
    loadedImages = 0;

    imageLoaded = function() {
      loadedImages++;

      // All completed, trigger done function
      if (loadedImages === imageSources.length) {
        done(images);
      }
    }

   	// Load images
    for (var i = 0; i < imageSources.length; i++) {
      try {
        images[i] = new Image();
        images[i].src = imageSources[i];
        images[i].onload = function() {
          imageLoaded();
        }
        images[i].onerror = function() {
          imageLoaded();
        }
      } catch (e) {
      }
    }
  }
};

var images = new Images();

export { images as Images }